import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_minus",
  "use": "icon_minus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_minus\"><path fill=\"currentColor\" d=\"M19 12.5h.5v-1H19v1Zm0-1H5v1h14v-1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol